"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPagesEventNames = void 0;
/**
 * Default pages analytics event types.
 *
 * @public
 */
var DefaultPagesEventNames;
(function (DefaultPagesEventNames) {
    DefaultPagesEventNames["PageView"] = "PAGE_VIEW";
    DefaultPagesEventNames["CTA"] = "CTA_CLICK";
    DefaultPagesEventNames["Website"] = "WEBSITE";
    DefaultPagesEventNames["DrivingDirection"] = "DRIVING_DIRECTIONS";
    DefaultPagesEventNames["PhoneCall"] = "CALL";
})(DefaultPagesEventNames = exports.DefaultPagesEventNames || (exports.DefaultPagesEventNames = {}));
//# sourceMappingURL=DefaultPagesEventNames.js.map